import _styled from "../../../../_snowpack/pkg/styled-components.js";
import React from '../../../../_snowpack/pkg/react.js'; // @ts-ignore

import { Button, Error } from '../../../css/index.js';
import { Link } from '../../../../_snowpack/pkg/react-router-dom.js';

var _StyledError = _styled(Error).withConfig({
  displayName: "SubscriptionServiceError___StyledError",
  componentId: "sc-13nvpq5-0"
})(["flex:1;"]);

export const SubscriptionServiceError = ({
  error
}) => {
  return /*#__PURE__*/React.createElement(_StyledError, null, `Arrr... ${error}`, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    to: `/settings/tenants`,
    style: {
      marginTop: '20px'
    }
  }, "Back to tenants page"));
};